// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Button } from "@/components/ui/button";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import ConsultationModal from "@/components/ConsultationModal";
// import TreatmentSearchBar from "@/components/TreatmentSearchBar";
// import CountryFlagsSection from "@/components/CountryFlagsSection";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
//   CheckCircle, Star, Clock, Users, Globe, Award, Phone, ChevronRight
// } from "lucide-react";
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/autoplay";

// import { Autoplay } from "swiper/modules";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

// const HERO_IMG = "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";
// // api/hero-slides
// function HeroSection() {
//   const [slides, setSlides] = useState([]);

//   useEffect(() => {
//     fetch(`${API}/hero-slides`)
//       .then(res => res.json())
//       .then(data => {
//         const activeSlides = data.filter(item => item.active);
//         setSlides(activeSlides);
//       })
//       .catch(err => console.log(err));
//   }, []);

//   return (
//     <section className="hero-gradient relative overflow-hidden" data-testid="hero-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div className="animate-fade-in-up">
//             <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-6 font-body text-xs uppercase tracking-wider" data-testid="hero-badge">
//               Trusted Medical Tourism Partner Since 2016
//             </Badge>
//             <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-slate-900 leading-tight mb-6" data-testid="hero-title">
//               World-Class Healthcare,{" "}
//               <span className="text-gradient-green">Made Affordable</span>
//             </h1>
//             <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-6 max-w-xl">
//               Access India's finest hospitals and specialists for medical treatments, dental care, and holistic wellness. Save up to 80% on treatment costs with personalized care.
//             </p>

//             {/* Treatment Search Bar */}
//             <div className="mb-8">
//               <TreatmentSearchBar variant="hero" />
//             </div>

//             <div className="flex flex-col sm:flex-row gap-4">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all text-base" data-testid="hero-cta-btn">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />
//               <a href="https://wa.me/917289007800" target="_blank" rel="noopener noreferrer">
//                 <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold transition-all text-base w-full sm:w-auto" data-testid="hero-whatsapp-btn">
//                   <Phone className="mr-2 h-4 w-4" /> Talk to Us
//                 </Button>
//               </a>
//             </div>
//           </div>
//           <div className="hidden lg:block relative">
//             <div className="relative rounded-2xl overflow-hidden shadow-2xl green-glow">
//               {/* <img src={HERO_IMG} alt="Medical professionals providing world-class care" className="w-full h-[480px] object-cover" /> */}
//               <Swiper
//                 modules={[Autoplay]}
//                 autoplay={{ delay: 3000 }}
//                 loop={true}
//                 className="w-full h-[480px]"
//               >
//                 {slides.map((slide) => (
//                   <SwiperSlide key={slide.id}>
//                     <div className="relative w-full h-[480px]">

//                       {/* Image */}
//                       <img
//                         src={slide.media_url}
//                         alt={slide.title}
//                         className="w-full h-full object-cover"
//                       />

//                       {/* Overlay */}
//                       <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 text-white">
//                         <h2 className="text-xl font-semibold">
//                           {slide.title}
//                         </h2>
//                         <p className="text-sm">
//                           {slide.subtitle}
//                         </p>
//                       </div>

//                     </div>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
//                 <div className="flex items-center gap-4 text-white">
//                   <div className="flex -space-x-2">
//                     {["AR", "GO", "DM"].map((a, i) => (
//                       <div key={i} className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white">{a}</div>
//                     ))}
//                   </div>
//                   <div>
//                     <p className="font-semibold text-sm">5,000+ Patients Served</p>
//                     <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />)}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CTAStrip() {
//   return (
//     <section className="cta-strip py-4" data-testid="cta-strip">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//           <div className="flex items-center gap-3 text-white">
//             <CheckCircle className="h-5 w-5" />
//             <span className="font-medium">Free Consultation</span>
//             <span className="hidden sm:inline text-white/50">|</span>
//             <CheckCircle className="hidden sm:block h-5 w-5" />
//             <span className="hidden sm:inline font-medium">No Hidden Costs</span>
//             <span className="hidden md:inline text-white/50">|</span>
//             <CheckCircle className="hidden md:block h-5 w-5" />
//             <span className="hidden md:inline font-medium">24/7 Support</span>
//           </div>
//           <ConsultationModal
//             trigger={
//               <Button className="bg-white text-orange-700 hover:bg-orange-50 rounded-full px-6 py-2 font-semibold text-sm" data-testid="cta-strip-btn">
//                 Book Now <ArrowRight className="ml-1 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// function StatsSection() {
//   const stats = [
//     { icon: Users, value: "5,000+", label: "Patients Served" },
//     { icon: Globe, value: "15+", label: "Countries" },
//     { icon: Award, value: "6", label: "Partner Hospitals" },
//     { icon: CheckCircle, value: "98%", label: "Success Rate" },
//   ];
//   return (
//     <section className="bg-slate-900 py-12" data-testid="stats-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//           {stats.map((s, i) => (
//             <div key={i} className="text-center">
//               <s.icon className="h-6 w-6 text-orange-600 mx-auto mb-2" />
//               <p className="text-2xl md:text-3xl font-bold text-white font-heading">{s.value}</p>
//               <p className="text-slate-400 text-sm">{s.label}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function SpecialtiesSection({ treatments }) {
//   const displayTreatments = treatments.slice(0, 8);
//   return (
//     <section className="py-20 md:py-28" data-testid="specialties-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Multi-Specialty Focus</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Treatments We Specialize In</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">From cardiac surgery to dental implants, we cover all medical needs with India's finest hospitals and specialists.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {displayTreatments.map((t) => {
//             const IconComp = ICONS[t.icon] || Heart;
//             return (
//               <Card key={t.id} className="bg-slate-50 hover:bg-white border border-transparent hover:border-emerald-300 rounded-xl p-6 transition-all cursor-pointer card-hover group" data-testid={`specialty-${t.id}`}>
//                 <div className="w-12 h-12 rounded-xl bg-orange-600/10 flex items-center justify-center mb-4 group-hover:bg-orange-600/20 transition-colors">
//                   <IconComp className="h-6 w-6 text-orange-600" />
//                 </div>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{t.name}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">{t.description}</p>
//                 {(t.price_range || t.price_from) && <p className="text-orange-600 font-semibold text-sm mt-3">{t.price_range || `From ${t.price_from}`}</p>}
//               </Card>
//             );
//           })}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/treatments">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-treatments-btn">
//               View All 16 Treatments <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function ProcessSection() {
//   const steps = [
//     { num: "01", title: "Share Your Case", desc: "Contact us with your medical details. Our team reviews your case within 24 hours.", icon: Phone },
//     { num: "02", title: "Get Treatment Plan", desc: "Receive expert medical opinions, cost estimates, and hospital options.", icon: CheckCircle },
//     { num: "03", title: "Travel to India", desc: "We handle visa, flights, airport pickup, and hotel accommodation.", icon: Globe },
//     { num: "04", title: "Get Treated & Recover", desc: "Receive world-class treatment. We stay with you for follow-ups.", icon: Heart },
//   ];
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="process-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">How It Works</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Your Journey to Better Health</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">Simple, transparent, and dependable - from your first contact to recovery and beyond.</p>
//         </div>
//         <div className="relative">
//           <div className="hidden md:block process-line"></div>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             {steps.map((s, i) => (
//               <div key={i} className="relative text-center" data-testid={`process-step-${i + 1}`}>
//                 <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg">
//                   <s.icon className="h-6 w-6 text-black" />
//                 </div>
//                 <span className="text-orange-600 font-bold text-sm font-body">{s.num}</span>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mt-1 mb-2">{s.title}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function HospitalsPreview({ hospitals }) {
//   const IMG = "https://images.pexels.com/photos/18470744/pexels-photo-18470744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
//   return (
//     <section className="py-20 md:py-28" data-testid="hospitals-preview-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Our Network</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Partner Hospital Network</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet hospitals before adding them to our panel, ensuring you receive the best care.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {Array.isArray(hospitals) && hospitals.slice(0, 4).map((h) => (
//             <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-all overflow-hidden card-hover" data-testid={`hospital-card-${h.id}`}>
//               <div className="h-36 bg-gradient-to-br from-orange-600/10 to-slate-50 flex items-center justify-center">
//                 <img src={IMG} alt={h.name} className="w-full h-full object-cover" />
//               </div>
//               <div className="p-4">
//                 <div className="flex items-center justify-between mb-1">
//                   <h3 className="font-heading text-sm font-semibold text-slate-900 line-clamp-1">{h.name}</h3>
//                 </div>
//                 <div className="flex items-center gap-2 mb-2">
//                   <Badge className="bg-orange-600/10 text-orange-600 border-0 text-[10px]">{h.accreditation}</Badge>
//                   <span className="text-slate-400 text-xs">{h.city}</span>
//                 </div>
//                 <p className="text-slate-600 text-xs leading-relaxed line-clamp-2">{h.description}</p>
//               </div>
//             </Card>
//           ))}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/hospitals">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-hospitals-btn">
//               View All Hospitals <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function TestimonialsSection({ testimonials }) {
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="testimonials-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Patient Stories</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">What Our Patients Say</h2>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {Array.isArray(testimonials) && testimonials.slice(0, 3).map((t) => (
//             <Card key={t.id} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm card-hover" data-testid={`testimonial-${t.id}`}>
//               <div className="flex gap-0.5 mb-4">{[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}</div>
//               <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-4">"{t.text}"</p>
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-sm font-bold text-black">{t.avatar}</div>
//                 <div>
//                   <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
//                   <p className="text-slate-400 text-xs">{t.country} - {t.treatment}</p>
//                 </div>
//               </div>
//             </Card>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function CTASection() {
//   return (
//     <section className="py-20 md:py-28" data-testid="cta-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 left-0 w-48 h-48 bg-orange-600/5 rounded-full blur-3xl"></div>
//           <div className="relative z-10">
//             <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">Ready to Start Your Healing Journey?</h2>
//             <p className="text-slate-300 max-w-xl mx-auto mb-8">Get a free, no-obligation consultation. Our medical team will provide personalized treatment options within 24 hours.</p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="cta-consultation-btn">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />
//               <a href="tel:+917289007800">
//                 <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base" data-testid="cta-call-btn">
//                   <Phone className="mr-2 h-4 w-4" /> +91 7289007800
//                 </Button>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default function HomePage() {
//   const [treatments, setTreatments] = useState([]);
//   const [hospitals, setHospitals] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//     axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
//     axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(console.error);
//   }, []);


//   return (
//     <div data-testid="home-page">
//       <HeroSection />
//       <CTAStrip />
//       <StatsSection />
//       <CountryFlagsSection />
//       <SpecialtiesSection treatments={treatments} />
//       <ProcessSection />
//       <HospitalsPreview hospitals={hospitals} />
//       <TestimonialsSection testimonials={testimonials} />
//       <CTASection />
//     </div>
//   );
// }

// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Button } from "@/components/ui/button";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import ConsultationModal from "@/components/ConsultationModal";
// import TreatmentSearchBar from "@/components/TreatmentSearchBar";
// import CountryFlagsSection from "@/components/CountryFlagsSection";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
//   CheckCircle, Star, Clock, Users, Globe, Award, Phone, ChevronRight
// } from "lucide-react";
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/autoplay";
// import "swiper/css/pagination";
// import "swiper/css/effect-fade";

// import { Autoplay, Pagination, EffectFade } from "swiper/modules";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

// function HeroSection() {
//   const [slides, setSlides] = useState([]);
// let navigate =useNavigate();
//   useEffect(() => {
//     fetch(`${API}/hero-slides`)
//       .then(res => res.json())
//       .then(data => {
//         const activeSlides = data.filter(item => item.active);
//         setSlides(activeSlides);
//       })
//       .catch(err => console.log(err));
//   }, []);

//   return (
//     <section className="relative w-full h-[100vh] min-h-[600px] max-h-[900px] overflow-hidden" data-testid="hero-section">
//       {/* Full-page Background Carousel */}
//       <div className="absolute inset-0 w-full h-full z-0">
//         {slides.length > 0 ? (
//           <Swiper
//             modules={[Autoplay, Pagination, EffectFade]}
//             autoplay={{ delay: 4000, disableOnInteraction: false }}
//             effect="fade"
//             fadeEffect={{ crossFade: true }}
//             pagination={{ clickable: true, el: '.hero-pagination' }}
//             loop={true}
//             className="w-full h-full"
//           >
//             {slides.map((slide) => (
//               <SwiperSlide key={slide.id}>
//                 <div className="relative w-full h-full">
//                   <img
//                     src={slide.media_url}
//                     alt={slide.title}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         ) : (
//           <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
//         )}
//       </div>

//       <div className="relative z-10 flex items-center h-full">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-16">
//           <div className="max-w-2xl mx-auto animate-fade-in-up flex flex-col items-center text-center">

//             {/* Treatment Search Bar */}
//             <div className="mb-8 w-full">
//               <TreatmentSearchBar variant="hero" />
//             </div>

//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all text-base">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />

//               {/* Talk to Us */}
//               <a
//                 href="https://wa.me/917289007800"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <Button
//                   variant="outline"
//                   className="border-2 border-white/40 text-white hover:bg-white/10 backdrop-blur-sm rounded-full px-8 py-6 font-semibold transition-all text-base w-full sm:w-auto"
//                 >
//                   <Phone className="mr-2 h-4 w-4" /> Talk to Us
//                 </Button>
//               </a>

//               {/* NEW BUTTON */}
//               <Button
//                 onClick={() => navigate("/cost-comparison")}
//                 className="bg-white text-black hover:bg-gray-200 rounded-full px-8 py-6 font-semibold shadow-lg transition-all text-base w-full sm:w-auto"
//               >
//                 Compare Cost
//               </Button>
//             </div>

//             {/* Trust indicators */}
//             <div className="mt-10 flex items-center justify-center gap-6">
//               <div className="flex -space-x-2">
//                 {["AR", "GO", "DM"].map((a, i) => (
//                   <div
//                     key={i}
//                     className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white/80 shadow-lg"
//                   >
//                     {a}
//                   </div>
//                 ))}
//               </div>
//               <div>
//                 <p className="font-semibold text-sm text-white">
//                   5,000+ Patients Served
//                 </p>
//                 <div className="flex gap-0.5 justify-center">
//                   {[...Array(5)].map((_, i) => (
//                     <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
//                   ))}
//                 </div>
//               </div>
//             </div>


//           </div>
//         </div>
//       </div>

//       {/* Slide Info Badge (bottom-right) */}
//       {slides.length > 0 && (
//         <div className="absolute bottom-8 right-8 z-10 hidden lg:block">
//           <div className="hero-pagination flex gap-2" />
//         </div>
//       )}
//     </section>
//   );
// }

// function CTAStrip() {
//   return (
//     <section className="cta-strip py-4" data-testid="cta-strip">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//           <div className="flex items-center gap-3 text-white">
//             <CheckCircle className="h-5 w-5" />
//             <span className="font-medium">Free Consultation</span>
//             <span className="hidden sm:inline text-white/50">|</span>
//             <CheckCircle className="hidden sm:block h-5 w-5" />
//             <span className="hidden sm:inline font-medium">No Hidden Costs</span>
//             <span className="hidden md:inline text-white/50">|</span>
//             <CheckCircle className="hidden md:block h-5 w-5" />
//             <span className="hidden md:inline font-medium">24/7 Support</span>
//           </div>
//           <ConsultationModal
//             trigger={
//               <Button className="bg-white text-orange-700 hover:bg-orange-50 rounded-full px-6 py-2 font-semibold text-sm" data-testid="cta-strip-btn">
//                 Book Now <ArrowRight className="ml-1 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// function StatsSection() {
//   const stats = [
//     { icon: Users, value: "5,000+", label: "Patients Served" },
//     { icon: Globe, value: "15+", label: "Countries" },
//     { icon: Award, value: "6", label: "Partner Hospitals" },
//     { icon: CheckCircle, value: "98%", label: "Success Rate" },
//   ];
//   return (
//     <section className="bg-slate-900 py-12" data-testid="stats-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//           {stats.map((s, i) => (
//             <div key={i} className="text-center">
//               <s.icon className="h-6 w-6 text-orange-600 mx-auto mb-2" />
//               <p className="text-2xl md:text-3xl font-bold text-white font-heading">{s.value}</p>
//               <p className="text-slate-400 text-sm">{s.label}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function SpecialtiesSection({ treatments }) {
//   const displayTreatments = treatments.slice(0, 8);
//   return (
//     <section className="py-20 md:py-28" data-testid="specialties-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Multi-Specialty Focus</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Treatments We Specialize In</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">From cardiac surgery to dental implants, we cover all medical needs with India's finest hospitals and specialists.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {displayTreatments.map((t) => {
//             const IconComp = ICONS[t.icon] || Heart;
//             return (
//               <Card key={t.id} className="bg-slate-50 hover:bg-white border border-transparent hover:border-emerald-300 rounded-xl p-6 transition-all cursor-pointer card-hover group" data-testid={`specialty-${t.id}`}>
//                 <div className="w-12 h-12 rounded-xl bg-orange-600/10 flex items-center justify-center mb-4 group-hover:bg-orange-600/20 transition-colors">
//                   <IconComp className="h-6 w-6 text-orange-600" />
//                 </div>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{t.name}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">{t.description}</p>
//                 {(t.price_range || t.price_from) && <p className="text-orange-600 font-semibold text-sm mt-3">{t.price_range || `From ${t.price_from}`}</p>}
//               </Card>
//             );
//           })}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/treatments">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-treatments-btn">
//               View All 16 Treatments <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function ProcessSection() {
//   const steps = [
//     { num: "01", title: "Share Your Case", desc: "Contact us with your medical details. Our team reviews your case within 24 hours.", icon: Phone },
//     { num: "02", title: "Get Treatment Plan", desc: "Receive expert medical opinions, cost estimates, and hospital options.", icon: CheckCircle },
//     { num: "03", title: "Travel to India", desc: "We handle visa, flights, airport pickup, and hotel accommodation.", icon: Globe },
//     { num: "04", title: "Get Treated & Recover", desc: "Receive world-class treatment. We stay with you for follow-ups.", icon: Heart },
//   ];
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="process-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">How It Works</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Your Journey to Better Health</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">Simple, transparent, and dependable - from your first contact to recovery and beyond.</p>
//         </div>
//         <div className="relative">
//           <div className="hidden md:block process-line"></div>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             {steps.map((s, i) => (
//               <div key={i} className="relative text-center" data-testid={`process-step-${i + 1}`}>
//                 <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg">
//                   <s.icon className="h-6 w-6 text-black" />
//                 </div>
//                 <span className="text-orange-600 font-bold text-sm font-body">{s.num}</span>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mt-1 mb-2">{s.title}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function HospitalsPreview({ hospitals }) {

//   return (
//     <section className="py-20 md:py-28" data-testid="hospitals-preview-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Our Network</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Partner Hospital Network</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet hospitals before adding them to our panel, ensuring you receive the best care.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {Array.isArray(hospitals) && hospitals.slice(0, 4).map((h) => (
//             <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-all overflow-hidden card-hover" data-testid={`hospital-card-${h.id}`}>
//               <div className="h-36 bg-gradient-to-br from-orange-600/10 to-slate-50 flex items-center justify-center">
//                 <img src={h.logo_url} alt={h.name} className="w-full h-full object-cover" />
//               </div>
//               <div className="p-4">
//                 <div className="flex items-center justify-between mb-1">
//                   <h3 className="font-heading text-sm font-semibold text-slate-900 line-clamp-1">{h.name}</h3>
//                 </div>
//                 <div className="flex items-center gap-2 mb-2">
//                   <Badge className="bg-orange-600/10 text-orange-600 border-0 text-[10px]">{h.accreditation}</Badge>
//                   <span className="text-slate-400 text-xs">{h.city}</span>
//                 </div>
//                 <p className="text-slate-600 text-xs leading-relaxed line-clamp-2">{h.description}</p>
//               </div>
//             </Card>
//           ))}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/hospitals">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-hospitals-btn">
//               View All Hospitals <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function TestimonialsSection({ testimonials }) {
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="testimonials-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Patient Stories</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">What Our Patients Say</h2>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {Array.isArray(testimonials) && testimonials.slice(0, 3).map((t) => (
//             <Card key={t.id} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm card-hover" data-testid={`testimonial-${t.id}`}>
//               <div className="flex gap-0.5 mb-4">{[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}</div>
//               <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-4">"{t.text}"</p>
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-sm font-bold text-black">{t.avatar}</div>
//                 <div>
//                   <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
//                   <p className="text-slate-400 text-xs">{t.country} - {t.treatment}</p>
//                 </div>
//               </div>
//             </Card>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function CTASection() {
//   return (
//     <section className="py-20 md:py-28" data-testid="cta-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 left-0 w-48 h-48 bg-orange-600/5 rounded-full blur-3xl"></div>
//           <div className="relative z-10">
//             <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">Ready to Start Your Healing Journey?</h2>
//             <p className="text-slate-300 max-w-xl mx-auto mb-8">Get a free, no-obligation consultation. Our medical team will provide personalized treatment options within 24 hours.</p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="cta-consultation-btn">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />
//               <a href="tel:+917289007800">
//                 <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base" data-testid="cta-call-btn">
//                   <Phone className="mr-2 h-4 w-4" /> +91 7289007800
//                 </Button>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default function HomePage() {
//   const [treatments, setTreatments] = useState([]);
//   const [hospitals, setHospitals] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//     axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
//     axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(console.error);
//   }, []);

//   return (
//     <div data-testid="home-page">
//       <HeroSection />
//       <CTAStrip />
//       <StatsSection />
//       <CountryFlagsSection />
//       <SpecialtiesSection treatments={treatments} />
//       <ProcessSection />
//       <HospitalsPreview hospitals={hospitals} />
//       <TestimonialsSection testimonials={testimonials} />
//       <CTASection />
//     </div>
//   );
// }

// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Button } from "@/components/ui/button";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import ConsultationModal from "@/components/ConsultationModal";
// import TreatmentSearchBar from "@/components/TreatmentSearchBar";
// import CountryFlagsSection from "@/components/CountryFlagsSection";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
//   CheckCircle, Star, Clock, Users, Globe, Award, Phone, ChevronRight
// } from "lucide-react";
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/autoplay";
// import "swiper/css/pagination";
// import "swiper/css/effect-fade";

// import { Autoplay, Pagination, EffectFade } from "swiper/modules";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

// function HeroSection() {
//   const [slides, setSlides] = useState([]);
//   let navigate = useNavigate();

//   useEffect(() => {
//     fetch(`${API}/hero-slides`)
//       .then(res => res.json())
//       .then(data => {
//         const activeSlides = data.filter(item => item.active);
//         setSlides(activeSlides);
//       })
//       .catch(err => console.log(err));
//   }, []);

//   return (
//     <section className="relative w-full overflow-hidden" data-testid="hero-section">
//       {/* Desktop View - Full Height */}
//       <div className="hidden md:block">
//         <div className="relative w-full h-[100vh] min-h-[632px] max-h-[632px]">
//           {/* Full-page Background Carousel */}
//           <div className="absolute inset-0 w-full h-full z-0">
//             {slides.length > 0 ? (
//               <Swiper
//                 modules={[Autoplay, Pagination, EffectFade]}
//                 autoplay={{ delay: 4000, disableOnInteraction: false }}
//                 effect="fade"
//                 fadeEffect={{ crossFade: true }}
//                 pagination={{ clickable: true, el: '.hero-pagination-desktop' }}
//                 loop={true}
//                 className="w-full h-full"
//               >
//                 {slides.map((slide) => (
//                   <SwiperSlide key={slide.id}>
//                     <div className="relative w-full h-full">
//                       <img
//                         src={slide.media_url}
//                         alt={slide.title}
//                         className="w-full h-full object-cover"
//                       />
//                       {/* Overlay gradient */}
//                       {/* <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" /> */}
//                     </div>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//             ) : (
//               <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
//             )}
//           </div>

//           {/* Content Overlay */}
//           <div className="relative z-10 flex items-center h-full">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-16">
//               <div className="max-w-2xl mx-auto animate-fade-in-up flex flex-col items-center mt-80 text-center">
//                 {/* Treatment Search Bar */}
//                 <div className="mb-8 w-full">
//                   <TreatmentSearchBar variant="hero" />
//                 </div>

//                 <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                   <ConsultationModal
//                     trigger={
//                       <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all text-base">
//                         Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                       </Button>
//                     }
//                   />

//                   <a
//                     href="https://wa.me/917289007800"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <Button
//                       variant="outline"
//                       className="border-2 border-white/40 text-white hover:bg-white/10 backdrop-blur-sm rounded-full px-8 py-6 font-semibold transition-all text-base w-full sm:w-auto"
//                     >
//                       <Phone className="mr-2 h-4 w-4" /> Talk to Us
//                     </Button>
//                   </a>

//                   <Button
//                     onClick={() => navigate("/cost-comparison")}
//                     className="bg-white text-black hover:bg-gray-200 rounded-full px-8 py-6 font-semibold shadow-lg transition-all text-base w-full sm:w-auto"
//                   >
//                     Compare Cost
//                   </Button>
//                 </div>

//                 {/* Trust indicators */}
//                 <div className="mt-10 flex items-center justify-center gap-6">
//                   <div className="flex -space-x-2">
//                     {["AR", "GO", "DM"].map((a, i) => (
//                       <div
//                         key={i}
//                         className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white/80 shadow-lg"
//                       >
//                         {a}
//                       </div>
//                     ))}
//                   </div>
//                   <div>
//                     <p className="font-semibold text-sm text-white">
//                       5,000+ Patients Served
//                     </p>
//                     <div className="flex gap-0.5 justify-center">
//                       {[...Array(5)].map((_, i) => (
//                         <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Slide Info Badge (bottom-right) */}
//           {slides.length > 0 && (
//             <div className="absolute bottom-8 right-8 z-10">
//               <div className="hero-pagination-desktop flex gap-2" />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Mobile View - Stacked Layout */}
//       <div className="md:hidden">
//         {/* Carousel Section */}
//         <div className="relative w-full h-[280px] sm:h-[320px]">
//           {slides.length > 0 ? (
//             <Swiper
//               modules={[Autoplay, Pagination]}
//               autoplay={{ delay: 3500, disableOnInteraction: false }}
//               pagination={{ 
//                 clickable: true, 
//                 el: '.hero-pagination-mobile',
//                 bulletClass: 'swiper-pagination-bullet !bg-white/60',
//                 bulletActiveClass: 'swiper-pagination-bullet-active !bg-orange-500'
//               }}
//               loop={true}
//               className="w-full h-full"
//             >
//               {slides.map((slide) => (
//                 <SwiperSlide key={slide.id}>
//                   <div className="relative w-full h-full">
//                     <img
//                       src={slide.media_url}
//                       alt={slide.title}
//                       className="w-full h-full object-cover"
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           ) : (
//             <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
//           )}
          
//           {/* Mobile Pagination */}
//           <div className="absolute bottom-4 left-0 right-0 z-10 flex justify-center">
//             <div className="hero-pagination-mobile" />
//           </div>
//         </div>

//         {/* Content Below Carousel */}
//         <div className="bg-white px-4 py-6 space-y-5">
//           {/* Search Bar */}
//           <div className="w-full">
//             <TreatmentSearchBar variant="hero" />
//           </div>

//           {/* Action Buttons */}
//           <div className="flex flex-col gap-3 w-full">
//             <ConsultationModal
//               trigger={
//                 <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6 py-6 font-semibold shadow-lg text-base">
//                   Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                 </Button>
//               }
//             />

//             <div className="grid grid-cols-2 gap-3">
//               <a
//                 href="https://wa.me/917289007800"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-full"
//               >
//                 <Button
//                   variant="outline"
//                   className="w-full border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-4 py-6 font-semibold transition-all text-sm"
//                 >
//                   <Phone className="mr-1.5 h-4 w-4" /> Talk to Us
//                 </Button>
//               </a>

//               <Button
//                 onClick={() => navigate("/cost-comparison")}
//                 className="w-full bg-slate-900 text-white hover:bg-slate-800 rounded-full px-4 py-6 font-semibold shadow-md transition-all text-sm"
//               >
//                 Compare Cost
//               </Button>
//             </div>
//           </div>

//           {/* Trust Indicator - Mobile */}
//           <div className="flex items-center justify-center gap-4 pt-2 pb-1">
//             <div className="flex -space-x-2">
//               {["AR", "GO", "DM"].map((a, i) => (
//                 <div
//                   key={i}
//                   className="w-9 h-9 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white shadow-md"
//                 >
//                   {a}
//                 </div>
//               ))}
//             </div>
//             <div>
//               <p className="font-semibold text-sm text-slate-900">
//                 5,000+ Patients Served
//               </p>
//               <div className="flex gap-0.5">
//                 {[...Array(5)].map((_, i) => (
//                   <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Inline CSS for pagination styling */}
//       <style>{`
//         .hero-pagination-mobile .swiper-pagination-bullet {
//           width: 8px;
//           height: 8px;
//           margin: 0 4px;
//         }
//         .hero-pagination-desktop .swiper-pagination-bullet {
//           width: 10px;
//           height: 10px;
//           background: rgba(255, 255, 255, 0.5);
//           margin: 0 6px;
//         }
//         .hero-pagination-desktop .swiper-pagination-bullet-active {
//           background: #ea580c;
//           width: 24px;
//           border-radius: 5px;
//         }
//         @keyframes fade-in-up {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fade-in-up {
//           animation: fade-in-up 0.8s ease-out;
//         }
//       `}</style>
//     </section>
//   );
// }

// function CTAStrip() {
//   return (
//     <section className="cta-strip py-4" data-testid="cta-strip">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//           <div className="flex items-center gap-3 text-white flex-wrap justify-center sm:justify-start">
//             <div className="flex items-center gap-2">
//               <CheckCircle className="h-5 w-5" />
//               <span className="font-medium text-sm">Free Consultation</span>
//             </div>
//             <span className="hidden sm:inline text-white/50">|</span>
//             <div className="flex items-center gap-2">
//               <CheckCircle className="h-5 w-5" />
//               <span className="font-medium text-sm">No Hidden Costs</span>
//             </div>
//             <span className="hidden md:inline text-white/50">|</span>
//             <div className="hidden md:flex items-center gap-2">
//               <CheckCircle className="h-5 w-5" />
//               <span className="font-medium text-sm">24/7 Support</span>
//             </div>
//           </div>
//           <ConsultationModal
//             trigger={
//               <Button className="bg-white text-orange-700 hover:bg-orange-50 rounded-full px-6 py-2 font-semibold text-sm" data-testid="cta-strip-btn">
//                 Book Now <ArrowRight className="ml-1 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// function StatsSection() {
//   const stats = [
//     { icon: Users, value: "5,000+", label: "Patients Served" },
//     { icon: Globe, value: "15+", label: "Countries" },
//     { icon: Award, value: "6", label: "Partner Hospitals" },
//     { icon: CheckCircle, value: "98%", label: "Success Rate" },
//   ];
//   return (
//     <section className="bg-slate-900 py-12" data-testid="stats-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//           {stats.map((s, i) => (
//             <div key={i} className="text-center">
//               <s.icon className="h-6 w-6 text-orange-600 mx-auto mb-2" />
//               <p className="text-2xl md:text-3xl font-bold text-white font-heading">{s.value}</p>
//               <p className="text-slate-400 text-sm">{s.label}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function SpecialtiesSection({ treatments }) {
//   const displayTreatments = treatments.slice(0, 8);
//   return (
//     <section className="py-20 md:py-28" data-testid="specialties-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Multi-Specialty Focus</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Treatments We Specialize In</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">From cardiac surgery to dental implants, we cover all medical needs with India's finest hospitals and specialists.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {displayTreatments.map((t) => {
//             const IconComp = ICONS[t.icon] || Heart;
//             return (
//               <Card key={t.id} className="bg-slate-50 hover:bg-white border border-transparent hover:border-emerald-300 rounded-xl p-6 transition-all cursor-pointer card-hover group" data-testid={`specialty-${t.id}`}>
//                 <div className="w-12 h-12 rounded-xl bg-orange-600/10 flex items-center justify-center mb-4 group-hover:bg-orange-600/20 transition-colors">
//                   <IconComp className="h-6 w-6 text-orange-600" />
//                 </div>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{t.name}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">{t.description}</p>
//                 {(t.price_range || t.price_from) && <p className="text-orange-600 font-semibold text-sm mt-3">{t.price_range || `From ${t.price_from}`}</p>}
//               </Card>
//             );
//           })}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/treatments">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-treatments-btn">
//               View All 16 Treatments <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function ProcessSection() {
//   const steps = [
//     { num: "01", title: "Share Your Case", desc: "Contact us with your medical details. Our team reviews your case within 24 hours.", icon: Phone },
//     { num: "02", title: "Get Treatment Plan", desc: "Receive expert medical opinions, cost estimates, and hospital options.", icon: CheckCircle },
//     { num: "03", title: "Travel to India", desc: "We handle visa, flights, airport pickup, and hotel accommodation.", icon: Globe },
//     { num: "04", title: "Get Treated & Recover", desc: "Receive world-class treatment. We stay with you for follow-ups.", icon: Heart },
//   ];
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="process-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">How It Works</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Your Journey to Better Health</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">Simple, transparent, and dependable - from your first contact to recovery and beyond.</p>
//         </div>
//         <div className="relative">
//           <div className="hidden md:block process-line"></div>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//             {steps.map((s, i) => (
//               <div key={i} className="relative text-center" data-testid={`process-step-${i + 1}`}>
//                 <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg">
//                   <s.icon className="h-6 w-6 text-black" />
//                 </div>
//                 <span className="text-orange-600 font-bold text-sm font-body">{s.num}</span>
//                 <h3 className="font-heading text-lg font-semibold text-slate-900 mt-1 mb-2">{s.title}</h3>
//                 <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function HospitalsPreview({ hospitals }) {
//   return (
//     <section className="py-20 md:py-28" data-testid="hospitals-preview-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Our Network</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Partner Hospital Network</h2>
//           <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet hospitals before adding them to our panel, ensuring you receive the best care.</p>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {Array.isArray(hospitals) && hospitals.slice(0, 4).map((h) => (
//             <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-all overflow-hidden card-hover" data-testid={`hospital-card-${h.id}`}>
//               <div className="h-36 bg-gradient-to-br from-orange-600/10 to-slate-50 flex items-center justify-center">
//                 <img src={h.logo_url} alt={h.name} className="w-full h-full object-cover" />
//               </div>
//               <div className="p-4">
//                 <div className="flex items-center justify-between mb-1">
//                   <h3 className="font-heading text-sm font-semibold text-slate-900 line-clamp-1">{h.name}</h3>
//                 </div>
//                 <div className="flex items-center gap-2 mb-2">
//                   <Badge className="bg-orange-600/10 text-orange-600 border-0 text-[10px]">{h.accreditation}</Badge>
//                   <span className="text-slate-400 text-xs">{h.city}</span>
//                 </div>
//                 <p className="text-slate-600 text-xs leading-relaxed line-clamp-2">{h.description}</p>
//               </div>
//             </Card>
//           ))}
//         </div>
//         <div className="text-center mt-10">
//           <Link to="/hospitals">
//             <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-hospitals-btn">
//               View All Hospitals <ChevronRight className="ml-1 h-4 w-4" />
//             </Button>
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }

// function TestimonialsSection({ testimonials }) {
//   return (
//     <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="testimonials-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-14">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Patient Stories</Badge>
//           <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">What Our Patients Say</h2>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {Array.isArray(testimonials) && testimonials.slice(0, 3).map((t) => (
//             <Card key={t.id} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm card-hover" data-testid={`testimonial-${t.id}`}>
//               <div className="flex gap-0.5 mb-4">{[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}</div>
//               <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-4">"{t.text}"</p>
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-sm font-bold text-black">{t.avatar}</div>
//                 <div>
//                   <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
//                   <p className="text-slate-400 text-xs">{t.country} - {t.treatment}</p>
//                 </div>
//               </div>
//             </Card>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function CTASection() {
//   return (
//     <section className="py-20 md:py-28" data-testid="cta-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 left-0 w-48 h-48 bg-orange-600/5 rounded-full blur-3xl"></div>
//           <div className="relative z-10">
//             <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">Ready to Start Your Healing Journey?</h2>
//             <p className="text-slate-300 max-w-xl mx-auto mb-8">Get a free, no-obligation consultation. Our medical team will provide personalized treatment options within 24 hours.</p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <ConsultationModal
//                 trigger={
//                   <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="cta-consultation-btn">
//                     Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//                   </Button>
//                 }
//               />
//               <a href="tel:+917289007800">
//                 <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base" data-testid="cta-call-btn">
//                   <Phone className="mr-2 h-4 w-4" /> +91 7289007800
//                 </Button>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default function HomePage() {
//   const [treatments, setTreatments] = useState([]);
//   const [hospitals, setHospitals] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//     axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
//     axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(console.error);
//   }, []);

//   return (
//     <div data-testid="home-page">
//       <HeroSection />
//       <CTAStrip />
//       <StatsSection />
//       <CountryFlagsSection />
//       <SpecialtiesSection treatments={treatments} />
//       <ProcessSection />
//       <HospitalsPreview hospitals={hospitals} />
//       <TestimonialsSection testimonials={testimonials} />
//       <CTASection />
//     </div>
//   );
// }


import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import ConsultationModal from "@/components/ConsultationModal";
import TreatmentSearchBar from "@/components/TreatmentSearchBar";
import CountryFlagsSection from "@/components/CountryFlagsSection";
import {
  Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
  Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
  CheckCircle, Star, Clock, Users, Globe, Award, Phone, ChevronRight
} from "lucide-react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import PackagesComponent from "./PackagesComponent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

function HeroSection() {
  const [slides, setSlides] = useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/hero-slides`)
      .then(res => res.json())
      .then(data => {
        const activeSlides = data.filter(item => item.active);
        setSlides(activeSlides);
      })
      .catch(err => console.log(err));
  }, []);

  return (
    <section className="relative w-full overflow-hidden" data-testid="hero-section">

      {/* ─────────────────────────────────────────────
          DESKTOP VIEW
      ───────────────────────────────────────────── */}
      <div className="hidden md:block">
        <div className="relative w-full h-[632px]">

          {/* Background Carousel */}
          <div className="absolute inset-0 w-full h-full z-0">
            {slides.length > 0 ? (
              <Swiper
                modules={[Autoplay, Pagination, EffectFade]}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                effect="fade"
                fadeEffect={{ crossFade: true }}
                pagination={{ clickable: true, el: '.hero-pagination-desktop' }}
                loop={true}
                className="w-full h-full"
              >
                {slides.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <div className="relative w-full h-full">
                      <img
                        src={slide.media_url}
                        alt={slide.title}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
            )}
          </div>

        

          {/* Content — pinned to bottom */}
          <div className="absolute bottom-0 left-0 right-0 z-[2] pb-14">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="max-w-2xl mx-auto animate-fade-in-up flex flex-col items-center text-center">
                <div className="mb-8 w-full">
                  <TreatmentSearchBar variant="hero" />
                </div>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <ConsultationModal
                    trigger={
                      <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all text-base">
                        Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
                      </Button>
                    }
                  />
                  <a href="https://wa.me/917289007800" target="_blank" rel="noopener noreferrer">
                    <Button
                      variant="outline"
                      className="border-2 border-white/40 text-white hover:bg-white/10 backdrop-blur-sm rounded-full px-8 py-6 font-semibold transition-all text-base w-full sm:w-auto"
                    >
                      <Phone className="mr-2 h-4 w-4" /> Talk to Us
                    </Button>
                  </a>
                  <Button
                    onClick={() => navigate("/cost-comparison")}
                    className="bg-white text-black hover:bg-gray-200 rounded-full px-8 py-6 font-semibold shadow-lg transition-all text-base w-full sm:w-auto"
                  >
                    Compare Cost
                  </Button>
                </div>
                <div className="mt-8 flex items-center justify-center gap-6">
                  <div className="flex -space-x-2">
                    {["AR", "GO", "DM"].map((a, i) => (
                      <div key={i} className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white/80 shadow-lg">
                        {a}
                      </div>
                    ))}
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-white">5,000+ Patients Served</p>
                    <div className="flex gap-0.5 justify-center">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pagination dots */}
          {slides.length > 0 && (
            <div className="absolute bottom-5 right-8 z-[3]">
              <div className="hero-pagination-desktop flex gap-2" />
            </div>
          )}
        </div>
      </div>

      {/* ─────────────────────────────────────────────
          MOBILE VIEW — Full image + content at bottom
      ───────────────────────────────────────────── */}
      <div className="md:hidden">
        <div className="relative w-full" style={{ paddingTop: '56.25%' }}>

          {/* Swiper absolutely fills the ratio box */}
          {slides.length > 0 ? (
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              pagination={{ clickable: true, el: '.hero-pagination-mobile' }}
              loop={true}
              style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '100%',
                height: '100%',
              }}
            >
              {slides.map((slide) => (
                <SwiperSlide key={slide.id} style={{ width: '100%', height: '100%' }}>
                  <img
                    src={slide.media_url}
                    alt={slide.title}
                    style={{
                      position: 'absolute',
                      inset: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      objectPosition: 'center center',
                      display: 'block',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div
              style={{
                position: 'absolute',
                inset: 0,
              }}
              className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
            />
          )}

          {/* Pagination dots — bottom of image */}
          <div
            style={{
              position: 'absolute',
              bottom: 10,
              left: 0,
              right: 0,
              zIndex: 10,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div className="hero-pagination-mobile" />
          </div>
        </div>

        {/* ── Content block — sits BELOW the image naturally ── */}
        <div className="mobile-content-block">

          {/* Search Bar */}
          <div className="w-full mb-3">
            <TreatmentSearchBar variant="hero" />
          </div>

          {/* Primary CTA */}
          <ConsultationModal
            trigger={
              <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-full py-5 font-semibold shadow-lg text-base mb-3">
                Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            }
          />

          {/* Secondary CTAs */}
          <div className="grid grid-cols-2 gap-3 mb-4">
            <a
              href="https://wa.me/917289007800"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <Button
                variant="outline"
                className="w-full border-2 border-white/50 text-white hover:bg-white/10 backdrop-blur-sm rounded-full py-5 font-semibold text-sm"
              >
                <Phone className="mr-1.5 h-4 w-4" /> Talk to Us
              </Button>
            </a>
            <Button
              onClick={() => navigate("/cost-comparison")}
              className="w-full bg-white text-slate-900 hover:bg-gray-100 rounded-full py-5 font-semibold shadow-md text-sm"
            >
              Compare Cost
            </Button>
          </div>

          {/* Trust Row */}
          <div className="flex items-center justify-center gap-4">
            <div className="flex -space-x-2">
              {["AR", "GO", "DM"].map((a, i) => (
                <div key={i} className="w-9 h-9 rounded-full bg-orange-600 flex items-center justify-center text-xs font-bold text-black border-2 border-white shadow-md">
                  {a}
                </div>
              ))}
            </div>
            <div>
              <p className="font-semibold text-sm text-white">5,000+ Patients Served</p>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Shared Styles ── */}
      <style>{`

        /* ══════════════════════════════════════
           MOBILE CONTENT BLOCK
        ══════════════════════════════════════ */
        .mobile-content-block {
          background: linear-gradient(to bottom, #0f172a, #0f172a);
          padding: 20px 16px 32px;
          width: 100%;
        }

        /* ══════════════════════════════════════
           SWIPER INTERNAL RESET
        ══════════════════════════════════════ */
        .swiper-wrapper {
          height: 100% !important;
        }
        .swiper-slide {
          height: 100% !important;
          width: 100% !important;
          position: relative !important;
        }

        /* ══════════════════════════════════════
           MOBILE PAGINATION BULLETS
        ══════════════════════════════════════ */
        .hero-pagination-mobile {
          display: flex !important;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
        .hero-pagination-mobile .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background: rgba(255,255,255,0.6);
          border-radius: 50%;
          opacity: 1;
          transition: all 0.3s ease;
          cursor: pointer;
          flex-shrink: 0;
          display: inline-block;
        }
        .hero-pagination-mobile .swiper-pagination-bullet-active {
          background: #ea580c;
          width: 22px;
          border-radius: 5px;
        }

        /* ══════════════════════════════════════
           DESKTOP PAGINATION BULLETS
        ══════════════════════════════════════ */
        .hero-pagination-desktop {
          display: flex;
          align-items: center;
        }
        .hero-pagination-desktop .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: rgba(255,255,255,0.5);
          margin: 0 5px;
          opacity: 1;
          transition: all 0.3s ease;
          display: inline-block;
        }
        .hero-pagination-desktop .swiper-pagination-bullet-active {
          background: #ea580c;
          width: 24px;
          border-radius: 5px;
        }

        /* ══════════════════════════════════════
           ANIMATIONS
        ══════════════════════════════════════ */
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out;
        }
      `}</style>
    </section>
  );
}

function CTAStrip() {
  return (
    <section className="cta-strip py-4" data-testid="cta-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3 text-white flex-wrap justify-center sm:justify-start">
            <div className="flex items-center gap-2">
              <CheckCircle className="h-5 w-5" />
              <span className="font-medium text-sm">Free Consultation</span>
            </div>
            <span className="hidden sm:inline text-white/50">|</span>
            <div className="flex items-center gap-2">
              <CheckCircle className="h-5 w-5" />
              <span className="font-medium text-sm">No Hidden Costs</span>
            </div>
            <span className="hidden md:inline text-white/50">|</span>
            <div className="hidden md:flex items-center gap-2">
              <CheckCircle className="h-5 w-5" />
              <span className="font-medium text-sm">24/7 Support</span>
            </div>
          </div>
          <ConsultationModal
            trigger={
              <Button className="bg-white text-orange-700 hover:bg-orange-50 rounded-full px-6 py-2 font-semibold text-sm" data-testid="cta-strip-btn">
                Book Now <ArrowRight className="ml-1 h-4 w-4" />
              </Button>
            }
          />
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { icon: Users, value: "5,000+", label: "Patients Served" },
    { icon: Globe, value: "15+", label: "Countries" },
    { icon: Award, value: "6", label: "Partner Hospitals" },
    { icon: CheckCircle, value: "98%", label: "Success Rate" },
  ];
  return (
    <section className="bg-slate-900 py-12" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <s.icon className="h-6 w-6 text-orange-600 mx-auto mb-2" />
              <p className="text-2xl md:text-3xl font-bold text-white font-heading">{s.value}</p>
              <p className="text-slate-400 text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function SpecialtiesSection({ treatments }) {
  const displayTreatments = treatments.slice(0, 8);
  return (
    <section className="py-20 md:py-28" data-testid="specialties-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Multi-Specialty Focus</Badge>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Treatments We Specialize In</h2>
          <p className="text-slate-500 max-w-2xl mx-auto">From cardiac surgery to dental implants, we cover all medical needs with India's finest hospitals and specialists.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {displayTreatments.map((t) => {
            const IconComp = ICONS[t.icon] || Heart;
            return (
              <Card key={t.id} className="bg-slate-50 hover:bg-white border border-transparent hover:border-emerald-300 rounded-xl p-6 transition-all cursor-pointer card-hover group" data-testid={`specialty-${t.id}`}>
                <div className="w-12 h-12 rounded-xl bg-orange-600/10 flex items-center justify-center mb-4 group-hover:bg-orange-600/20 transition-colors">
                  <IconComp className="h-6 w-6 text-orange-600" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{t.name}</h3>
                <p className="text-slate-500 text-sm leading-relaxed line-clamp-2">{t.description}</p>
                {(t.price_range || t.price_from) && (
                  <p className="text-orange-600 font-semibold text-sm mt-3">
                    {t.price_range || `From ${t.price_from}`}
                  </p>
                )}
              </Card>
            );
          })}
        </div>
        <div className="text-center mt-10">
          <Link to="/treatments">
            <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-treatments-btn">
              View All 16 Treatments <ChevronRight className="ml-1 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

function ProcessSection() {
  const steps = [
    { num: "01", title: "Share Your Case", desc: "Contact us with your medical details. Our team reviews your case within 24 hours.", icon: Phone },
    { num: "02", title: "Get Treatment Plan", desc: "Receive expert medical opinions, cost estimates, and hospital options.", icon: CheckCircle },
    { num: "03", title: "Travel to India", desc: "We handle visa, flights, airport pickup, and hotel accommodation.", icon: Globe },
    { num: "04", title: "Get Treated & Recover", desc: "Receive world-class treatment. We stay with you for follow-ups.", icon: Heart },
  ];
  return (
    <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">How It Works</Badge>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Your Journey to Better Health</h2>
          <p className="text-slate-500 max-w-2xl mx-auto">Simple, transparent, and dependable - from your first contact to recovery and beyond.</p>
        </div>
        <div className="relative">
          <div className="hidden md:block process-line"></div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {steps.map((s, i) => (
              <div key={i} className="relative text-center" data-testid={`process-step-${i + 1}`}>
                <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg">
                  <s.icon className="h-6 w-6 text-black" />
                </div>
                <span className="text-orange-600 font-bold text-sm font-body">{s.num}</span>
                <h3 className="font-heading text-lg font-semibold text-slate-900 mt-1 mb-2">{s.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function HospitalsPreview({ hospitals }) {
  return (
    <section className="py-20 md:py-28" data-testid="hospitals-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Our Network</Badge>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">Partner Hospital Network</h2>
          <p className="text-slate-500 max-w-2xl mx-auto">We rigorously vet hospitals before adding them to our panel, ensuring you receive the best care.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {Array.isArray(hospitals) && hospitals.slice(0, 4).map((h) => (
            <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-all overflow-hidden card-hover" data-testid={`hospital-card-${h.id}`}>
              <div className="h-36 bg-gradient-to-br from-orange-600/10 to-slate-50 flex items-center justify-center overflow-hidden">
                <img src={h.logo_url} alt={h.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-heading text-sm font-semibold text-slate-900 line-clamp-1">{h.name}</h3>
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <Badge className="bg-orange-600/10 text-orange-600 border-0 text-[10px]">{h.accreditation}</Badge>
                  <span className="text-slate-400 text-xs">{h.city}</span>
                </div>
                <p className="text-slate-600 text-xs leading-relaxed line-clamp-2">{h.description}</p>
              </div>
            </Card>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/hospitals">
            <Button variant="outline" className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 rounded-full px-8 py-6 font-semibold" data-testid="view-all-hospitals-btn">
              View All Hospitals <ChevronRight className="ml-1 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection({ testimonials }) {
  return (
    <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Patient Stories</Badge>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900 mb-4">What Our Patients Say</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Array.isArray(testimonials) && testimonials.slice(0, 3).map((t) => (
            <Card key={t.id} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm card-hover" data-testid={`testimonial-${t.id}`}>
              <div className="flex gap-0.5 mb-4">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-4">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-orange-600 flex items-center justify-center text-sm font-bold text-black">{t.avatar}</div>
                <div>
                  <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
                  <p className="text-slate-400 text-xs">{t.country} - {t.treatment}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="py-20 md:py-28" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900 rounded-3xl p-10 md:p-16 text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-orange-600/5 rounded-full blur-3xl"></div>
          <div className="relative z-10">
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">Ready to Start Your Healing Journey?</h2>
            <p className="text-slate-300 max-w-xl mx-auto mb-8">Get a free, no-obligation consultation. Our medical team will provide personalized treatment options within 24 hours.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <ConsultationModal
                trigger={
                  <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold shadow-lg text-base" data-testid="cta-consultation-btn">
                    Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                }
              />
              <a href="tel:+917289007800">
                <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-6 font-semibold text-base" data-testid="cta-call-btn">
                  <Phone className="mr-2 h-4 w-4" /> +91 7289007800
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  const [treatments, setTreatments] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
    axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
    axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(console.error);
  }, []);

  return (
    <div data-testid="home-page">
      <HeroSection />
      <CTAStrip />
      <StatsSection />
      <CountryFlagsSection />
      <SpecialtiesSection treatments={treatments} />
      <ProcessSection />
      <HospitalsPreview hospitals={hospitals} />
      <PackagesComponent/>
      <TestimonialsSection testimonials={testimonials} />
      <CTASection />
    </div>
  );
}